define('modules/profiles/subviews/views/profile.open.menu.view',[
    'client',
    'jquery',
    'underscore',
    'backbone',
    "marionette",
    "modules/profiles/subviews/views/profile.open.full.view",
    "text!modules/profiles/subviews/templates/profile.open.full.template.html"
], function (Prospector,
             $, _, Backbone, Marionette,
             ModelView,
             Template) {
    var ProfileOpenFullView = ModelView.extend({
        template: _.template("Open Full RelPro Profile"),
        tagName: 'li',
        className: "",
        attributes:{
            "value": "7"
        }
    });
    return ProfileOpenFullView;
});

